<template>
  <div>
    <b-modal
      id="modal-historico-lancamentos"
      size="xl"
      centered
      ok-only
      ok-title="Fechar"
      :lazy="true"
      @hidden="$emit('fechar')"
    >
    <template #modal-title>
      {{ titulo }}
    </template>
    <b-row>
      <b-col sm="6" class="mb-2">
        <b-row>
          <b-col sm="6">
            <small>Período:<strong>{{ dt1formatado }} a {{ dt2formatado }}</strong></small>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <small>Valor:<strong>{{ total }}</strong></small>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="6">
        <b-pagination
          v-model="currentPage"
          :total-rows="data.length"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-row>
        <b-col sm="12">
          <b-table 
            striped 
            hover
            stacked="md"
            small
            responsive 
            :current-page="currentPage"
            :per-page="perPage"
            :busy="busy"
            :items="data" 
            :fields="fields">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Carregando...</strong>
              </div>
            </template>
            <template #cell(TIPO)="item"><span :class="colorirTipo(item.item.TIPO)">{{item.item.TIPO}}</span></template>
          </b-table>
        </b-col>
      </b-row>
      <template #modal-footer>

        <b-button variant="outline-primary" @click="exportarHtml()">
           <span> <i  class="fa fa-print"></i></span>
          Imprimir
        </b-button>
        <b-button variant="outline-primary" class="ml-2" @click="exportarExcel()">
          <span> <i  class="fa fa-file-excel-o"></i></span>
           Excel
        </b-button>
        <b-button variant="outline-primary" class="ml-2" @click="exportarCsv()">
          <span> <i  class="fa fa-file-excel-o"></i></span>
           CSV
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('modal-historico-lancamentos')">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Tools from '@/tools/tools.js'
import moment from 'moment'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';

export default {
  name: 'ModalHistoricoLancamentos',
  props: {
    incGerar: { type: Number, default: 0 }, // controla o pesquisar
    itemId: { type: [Number, String], default: null }, // não required
    tipoFiltro: { type: String, default: 'HISTORICO' },          // input date -> string
    tipoMovimento: { type: String, default: '' },                      // input date -> string
    dt1: { type: String, default: '' },                      // input date -> string
    dt2: { type: String, default: '' },
    titulo: { type: String, default: '' }
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      data: [],
      busy: false,
      fields: [
          {
            key: "DOCUMENTO",
            sortable: true,
            label: 'Documento'
          },
          {
            key: "DT_MOV",
            sortable: true,
            label: 'Data Movimento',
            type:'date',
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "NOME_HISTORICO",
            sortable: true,
            label: 'Histórico'
          },
          {
            key: "NOME_CLIENTE",
            sortable: true,
            label: 'Cliente\Fornecedor'
          },
          {
            key: "COD_CENTRO1",
            sortable: true,
            label: 'Centro Custo'
          },

          {
            key: "OBS",
            sortable: true,
            label: 'Descrição'
          },
          {
            key: "FORMA",
            sortable: true,
            label: 'Tipo Documento'
          },
          {
            key: "TIPO",
            sortable: true,
            label: 'Lançamento'
          },
          {
            key: 'USUARIO_INCLUSAO', 
            label: 'Usuário', 
            sortable: true,
            thStyle: { width: '5% !important'}
          },
          {
            key: 'VL_MOV', 
            sortable: true,
            class:'text-right', 
            label: 'Débito (R$)',
            type:'currency', 
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          }
        ]
    }
  },
  methods: {
    colorirTipo(tipo) {
      return tipo === 'CREDITO' ? 'text-success' : 'text-danger'
    },
    async tryAutoFetch () {
      if (this.dt1 && this.dt2) await this.pesquisar()
    },
    async pesquisar() {
      try {
        this.currentPage = 0
        this.busy = true

        let params = {
          dt1: this.dt1,
          dt2: this.dt2
        }
        if (this.tipoFiltro === 'HISTORICO') {
          params.historicoId = this.itemId
        } else if (this.tipoFiltro === 'CENTRO_CUSTO') {
          params.centroCustoId = this.itemId
        } else if (this.tipoFiltro === 'HISTORICO_GERAL_CREDITO') {
          params.tipoMovimento = 'credito'
        } else if (this.tipoFiltro === 'HISTORICO_GERAL_DEBITO') {
          params.tipoMovimento = 'debito'
        } else if (this.tipoFiltro === 'CENTRO_CUSTO_GERAL') {
          // nenhum filtro adicional
        } else if (this.tipoFiltro === 'GERAL') {
          // nenhum filtro adicional
        }

        // Lógica para pesquisar débitos no período entre dt1 e dt2
        const {data} = await this.$http.get('/api/protected/caixa/item/listar', {
          params: params
        })
        this.data = data
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Não foi possível buscar os dados', 'danger', error)
      } finally {
        this.busy = false
      }
    },
    async abrirModal() {
      await this.pesquisar()
      this.$bvModal.show('modal-historico-lancamentos')
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.data,                 // seu array de dados
        columns: this.fields,
        systemName: 'CECWeb',
        reportTitle: this.titulo,
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Período: ${this.dt1} a ${this.dt2}`,
        pageSize: 'A4',
        landscape: true,                    // vira “deitado” se quiser
        footerTotals: [
          // soma só a coluna DEBITO (usa key da coluna)
          { key:'VL_MOV', formatter: v => v.toLocaleString('pt-BR',{style:'currency',currency:'BRL'}) }
        ],
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.data,
        columns: this.fields,
        filename: this.titulo + '.xls',
         sumKey: 'VL_MOV'              // mesma key da sua coluna de Débito (soma no rodapé)
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.data,
        columns: this.fields,
        filename: this.titulo + '.csv',
      });
    }
  },
  computed: {
    total() {
      const total = this.data.reduce((sum, item) => sum + (item.VL_MOV || 0), 0)
      return total.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    },
    dt1formatado() {
      return this.dt1 ? moment(String(this.dt1)).format('DD/MM/YYYY') : ''
    },
    dt2formatado() {
      return this.dt2 ? moment(String(this.dt2)).format('DD/MM/YYYY') : ''
    }
  },
  watch: {
    // se props mudarem depois de montado e já estiver aberto
    //async itemId () { await this.tryAutoFetch() },
    //async tipoFiltro () { await this.tryAutoFetch() },
    //async titulo () { await this.tryAutoFetch() }
    async incGerar () { await this.tryAutoFetch() }
  },
  async mounted () {
    // se quiser auto-carregar ao abrir:
    await this.tryAutoFetch()
  },
}
</script>


// WEBPACK FOOTER //
// src/views/dashboard/ModalHistoricoLancamentos.vue